export default "__VITE_ASSET__CEhuY_8I__"